import { CartesianChart, type CartesianChartProps } from './CartesianChart';

export type BarChartProps = Omit<CartesianChartProps, 'marks'>;

/** Grouped bar chart — one bar per series inside every x-band. */
export const BarChart = (props: BarChartProps) => <CartesianChart {...props} marks='bars' />;

BarChart.displayName = 'BarChart';
